import { render, staticRenderFns } from "./userRoleDetailEC.vue?vue&type=template&id=353a7646&"
import script from "./userRoleDetailEC.vue?vue&type=script&lang=js&"
export * from "./userRoleDetailEC.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetailEC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports